// Global utility functions and classes for the theme
// Make fetchSection globally accessible
window.fetchSection = (url) =>
  fetch(url)
    .then((res) => res.text())
    .then((html) =>
      new DOMParser()
        .parseFromString(html, 'text/html')
        .querySelector('.shopify-section')
    )

// Global Popup class for theme-wide use
window.Popup = class Popup {
  constructor(html) {
    this.html = html
    this.initialise()
  }

  initialise() {
    console.log('initialising popup')
    // Create overlay if it doesn't exist
    if (!window.overlay) {
      window.overlay = {
        loading: false,
        close: () => {
          if (window.popup) {
            window.popup.destroy()
          }
        }
      }
    }

    // Close existing popup
    if (window.popup) {
      window.popup.destroy()
    }

    // Only insert content if HTML is provided
    if (this.html) {
      this.insertContent(this.html)
    }
    window.popup = this
  }

  insertContent(html) {
    this.popup = document.createElement('div')
    this.popup.className = 'popup-overlay'
    this.popup.innerHTML = `
      <div class="popup-container">
        <button class="popup-close-btn" data-popup-close>
          <svg class="popup-close-icon" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path>
          </svg>
        </button>
        <div class="popup-content" data-popup-content>${html}</div>
      </div>
    `
    
    document.body.appendChild(this.popup)
    
    // Add close functionality
    this.popup.addEventListener('click', (e) => {
      if (e.target.closest('[data-popup-close]') || e.target === this.popup) {
        this.close()
      }
    })

    // Add escape key functionality
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') {
        this.close()
      }
    })
  }

  close() {
    this.popup.classList.add('popup-closing')
    setTimeout(() => {
      this.destroy()
    }, 200)
  }

  destroy() {
    if (this.popup) {
      this.popup.remove()
      window.popup = null
    }
  }

  /**
   * Updates currently open popup with new HTML
   */
  replaceContent(html) {
    if (this.popup) {
      this.popup.querySelector('[data-popup-content]').innerHTML = html
    }
  }

  /**
   * Returns the current popup element
   */
  get el() {
    return this.popup
  }
}